module.exports = __webpack_public_path__ + "img/jackie-shroff.96b6a792.jpg";